import script from "./SynchronisationObject.vue?vue&type=script&setup=true&lang=js"
export * from "./SynchronisationObject.vue?vue&type=script&setup=true&lang=js"

import "./SynchronisationObject.vue?vue&type=style&index=0&id=8a2d4642&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a2d4642"]])

export default __exports__